import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator, ValidationErrors} from '@angular/forms';
import {createStaticValidator} from './common';

export const SpaceChar = createStaticValidator((control: AbstractControl) => !String(control.value).includes(' '), {
  space: true,
});

@Directive({
  selector: '[spaceChar]',
  providers: [{provide: NG_VALIDATORS, useExisting: SpaceCharDirective, multi: true}],
})
export class SpaceCharDirective implements Validator {
  validate = SpaceChar;
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/space-char.validator.ts